import axios from "axios";
import settings, { getApiHost } from "../src/settings";

export default {
  user: {
    login: (credentials) =>
      axios
        .post(
          `${getApiHost(settings.env)}/userAuth.aspx`,
          {
            username: credentials.username,
            password: credentials.password,
            appname: credentials.appname,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    userSession: (sessionId) =>
      axios
        .post(
          `${getApiHost(settings.env)}/userSession.aspx`,
          {
            sessionId,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    sendSecurityToken: (appname) =>
      axios
        .post(
          `${getApiHost(settings.env)}/sendSecurityToken.aspx`,
          {
            appname,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    validateSecurityToken: (securityToken, appname) =>
      axios
        .post(
          `${getApiHost(settings.env)}/validateSecurityToken.aspx`,
          {
            securityToken,
            appname,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    userProfileUpdate: (usercode, themeOption, searchBySsn) =>
      axios
        .post(
          `${getApiHost(settings.env)}/userProfileUpdate.aspx`,
          {
            userCode: usercode,
            themeOption,
            searchBySsn,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    logout: (credentials) =>
      axios
        .post(
          `${getApiHost(settings.env)}/userLogout.aspx`,
          {
            username: credentials.username,
            appname: settings.appName,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    renewToken: (credentials) =>
      axios
        .post(
          `${getApiHost(settings.env)}/renewToken.aspx`,
          {
            sessionId: credentials.sessionId,
            appName: credentials.appName,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    getSecQuestions: () =>
      axios
        .post(
          `${getApiHost(settings.env)}/qaQuestions.aspx`,
          {
            reqQuestions: settings.reqQuestions,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    checkQaSetup: (params) =>
      axios
        .post(
          `${getApiHost(settings.env)}/hasQaSetup.aspx`,
          {
            appName: settings.appName,
            usercode: params.usercode,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    getQaQuestionsList: (params) =>
      axios
        .post(
          `${getApiHost(settings.env)}/qaQuestionsList.aspx`,
          {
            appName: settings.appName,
            usercode: params.usercode,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    setupQa: (usercode, qaList) =>
      axios
        .post(
          `${getApiHost(settings.env)}/setupQa.aspx`,
          {
            usercode,
            qaList,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    getSearchUi: () =>
      axios
        .post(
          `${getApiHost(settings.env)}/searchUi.aspx`,
          {
            appName: settings.appName,
          },
          { async: false }
        )
        .then((res) => res),
    validateToken: (token) => axios.post("/api/auth/validate_token", { token }),
    resetPasswordToTemp: (payload) =>
      axios
        .post(`${getApiHost(settings.env)}/sendEmail.aspx`, payload, {
          async: false,
        })
        .then((res) => res),
    changePassword: (payload) =>
      axios
        .post(`${getApiHost(settings.env)}/changePassword.aspx`, payload, {
          async: false,
        })
        .then((res) => res),
    checkSec: (qaList) =>
      axios
        .post(
          `${getApiHost(settings.env)}/qaCheck.aspx`,
          { appName: settings.appName, qaList },
          { async: false }
        )
        .then((res) => res),
    checkGlbSetup: (userCode) =>
      axios
        .post(
          `${getApiHost(settings.env)}/hasGlbSetup.aspx`,
          {
            appName: settings.appName,
            userCode,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
    getDisclosures: (userCode, mastType, mastState, isInitialSetup) =>
      axios
        .post(
          `${getApiHost(settings.env)}/disclosures.aspx`,
          {
            appName: settings.appName,
            userCode,
            mastType,
            mastState,
            isInitialSetup,
          },
          { async: false }
        )
        .then((res) => res),
    setupGlb: (usercode, glbPurpose) =>
      axios
        .post(
          `${getApiHost(settings.env)}/setupGlb.aspx`,
          {
            usercode,
            glbPurpose,
          },
          {
            async: false,
          }
        )
        .then((res) => res),
  },
  lpUtil: {
    getStates: (data) =>
      axios
        .post(
          `${getApiHost(settings.env)}/states.aspx`,
          {
            appName: settings.appName,
            ReportId: data.reportId,
            FormId: data.formId,
          },
          { async: true }
        )
        .then((res) => res),
    getSearchStates: () =>
      axios
        .post(
          `${getApiHost(settings.env)}/searchStates.aspx`,
          {
            appName: settings.appName,
          },
          { async: true }
        )
        .then((res) => res),
    getDppas: () =>
      axios
        .post(
          `${getApiHost(settings.env)}/dppa.aspx`,
          {
            appName: settings.appName,
          },
          { async: true }
        )
        .then((res) => res),
    getUserGlb: () =>
      axios
        .post(
          `${getApiHost(settings.env)}/userGlb.aspx`,
          {
            appName: settings.appName,
          },
          { async: true }
        )
        .then((res) => res),
    validateRecaptcha: (payload) =>
      axios
        .post(`${getApiHost(settings.env)}/validateRecaptcha.aspx`, payload, {
          async: false,
        })
        .then((res) => res),
  },
  lp: {
    homeValueAndIncome: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/homeValueAndIncome.aspx`, params, {
          async: true,
        })
        .then((res) => res),
    getActivitiesView: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/activitiesView.aspx`, params, {
          async: true,
        })
        .then((res) => res),
    piplRecordCounts: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/piplRecordCounts.aspx`, params, {
          async: true,
        })
        .then((res) => res),
    getStatementRange: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/getStatementRange.aspx`, params, {
          async: true,
        })
        .then((res) => res),
    getRemainingSearchCount: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/getRemainingSearchCount.aspx`, params, {
          async: true,
        })
        .then((res) => res),
    getCaseCostDetails: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/caseCosts.aspx`, params, {
          async: true,
        })
        .then((res) => res),
    processCases: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/cases.aspx`, params, {
          async: false,
        })
        .then((res) => res),
    processUserCosts: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/userCosts.aspx`, params, {
          async: false,
        })
        .then((res) => res),
    updateCaseContents: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/caseContents.aspx`, params, {
          async: false,
        })
        .then((res) => res),
    getActivityFieldValues: (params) =>
      axios
        .post(`${getApiHost(settings.env)}/activityFieldValues.aspx`, params, {
          async: false,
        })
        .then((res) => res),
  },
  report: {
    person: (params, cancelToken) =>
      axios
        .post(
          `${getApiHost(settings.env)}/PersonReport.aspx`,
          params,
          {
            async: true,
          },
          { cancelToken }
        )
        .then((res) => res),
  },
};



// WEBPACK FOOTER //
// ./src/api.js